const Backbone = require('backbone');
const Cart = require('./cart');

const Model = new Backbone.Model({
	codigo: '',
	desconto: 0.0
});

Model.on('change:desconto', function() {
	var desconto = Model.get('desconto');
	Cart.set({
		desconto: desconto
	});

	jQuery('[name=desconto]').val('R$' + (desconto.number_format(2,',','.')));
});

module.exports = Model;


//////////////////
// WEBPACK FOOTER
// ../src/carrinho/models/cupom.js
// module id = 11
// module chunks = 0